<div class="flex flex-col flex-auto overflow-y-auto lg:overflow-hidden h-full gap-2">

    <ng-container>
        <mat-drawer-container
            class="flex-auto h-full"
            [hasBackdrop]="false">

            <!-- Drawer content -->
            <mat-drawer-content class="d-flex flex-col overflow-hidden" >

                <!-- Conversation -->
                <div class="flex overflow-y-auto flex-col-reverse">
                    <div class="flex flex-col flex-auto flex-shrink gap-2">
                        <ng-container class="m-3 p-3" *ngFor="let message of menssage; let i = index; let first = first; let last = last; trackBy: trackByFn">
                            <div
                                class=" flex flex-col text-14px"
                                [ngClass]="{'items-end': (message.user_id === currentuser_id),
                                        'items-start': !(message.user_id === currentuser_id)}">
                                <!-- Bubble -->
                                <div
                                    class="relative max-w-3/4 px-3 py-2 rounded-md flex flex-col gap-1 text-chat"
                                    [ngClass]="{'bg-chat-right': (message.user_id === currentuser_id),
                                            'bg-chat-left': !(message.user_id === currentuser_id)}">

                                    <div class="font-semibold">{{message.name}}</div>
                                    <!-- Message -->
                                    <div
                                        style=" overflow-wrap: break-word"
                                        class="min-w-4 leading-5 whitespace-pre-line leading-relaxed"
                                        [innerHTML]="message.comment">
                                    </div>
                                    <!-- Time -->
                                    <ng-container >
                                        <div class="my-0.5 text-chat text-end">
                                            {{message.datetime | date : 'MM/dd/yyyy, HH:mm:ss'}}
                                        </div>
                                    </ng-container>
                                </div>

                            </div>
                        </ng-container>
                    </div>
                </div>
            </mat-drawer-content>

        </mat-drawer-container>

        <!-- Message field -->
        <div class="flex items-end messageField">
            <div class="input-group">
                <button
                  mat-icon-button
                  class="btnOpenFile d-flex align-items-center justify-content-center"
                  (click)="openFileSelector()">
                  <mat-icon class="material-symbols-rounded">attach_file</mat-icon>
                </button>
                <textarea
                    class="form-control resize-none"
                    [rows]="1"
                    placeholder="Start typing..."
                    #messageInput
                    (keypress)='enterpress($event)'
                    [(ngModel)]="text">
                </textarea>
                <button
                  mat-icon-button
                  class="btnSend d-flex align-items-center justify-content-center"
                  (click)="insert()">
                  <mat-icon class="material-symbols-rounded">send</mat-icon>
                </button>
              </div>

        </div>
    </ng-container>

</div>
